interface DirectionsDrivingProps {
  companyName: string;
  traffowner: string;
  parkcnt: number;
  hasParkinglot: boolean;
}

export const DirectionsDriving = ({
  companyName,
  traffowner,
  parkcnt,
  hasParkinglot,
}: DirectionsDrivingProps) => {
  if (!traffowner && !parkcnt && !hasParkinglot) return null;

  return (
    <section className="dr-section" aria-labelledby="dr-driving-title">
      <h2 id="dr-driving-title" className="dr-section__title">
        {`${companyName} 자가용 · 주차 안내`}
      </h2>
      <p className="dr-section__lede">자가용 경로와 주차장 정보입니다.</p>

      <table className="dr-info-table" aria-label={`${companyName} 주차 정보`}>
        <tbody>
          <tr>
            <th scope="row">주차장</th>
            <td>{hasParkinglot ? "이용 가능" : "정보 없음"}</td>
          </tr>
          <tr>
            <th scope="row">주차 규모</th>
            <td>
              {parkcnt > 0 ? `${parkcnt.toLocaleString()}대` : "확인 필요"}
            </td>
          </tr>
        </tbody>
      </table>

      {traffowner && (
        <>
          <h3 className="dr-section__subtitle">자가용 경로 안내</h3>
          <div className="dr-raw-text">{traffowner}</div>
        </>
      )}
    </section>
  );
};
